// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : REMOVED UNUSED SERVICES
// MODIFIED DATE: 26-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/************* FETCH REPAYMENT COLLECTION REPORT START *********************** */
export const fetchPostRepaymentCollection = (branchData: any) => {
	const data = {
		FetchRepayMembersListToken: branchData,
	};
	const url = `${API_URL}repaymentCollectionReport`;
	return makeApiCall(url, data);
};
/************* FETCH REPAYMENT COLLECTION REPORT END *********************** */
